import React from 'react';
import { useSelector } from 'react-redux';
import { Row, Col, Divider } from 'antd';
import { ReactComponent as EdgelIcon } from '../../../../../assets/icons/edge.svg';
import { ReactComponent as GreyPoint } from '../../../../../assets/icons/graphGreyPoint.svg';
import { ReactComponent as BluePoint } from '../../../../../assets/icons/graphPurplePoint.svg';
import { ReactComponent as DarkBluePoint } from '../../../../../assets/icons/graphDarkPurple.svg';
import { ReactComponent as PurplePoint } from '../../../../../assets/icons/graphPurplePoint.svg';
import { ReactComponent as BlueEdge } from '../../../../../assets/icons/graphPurpluEdge.svg';
import { ReactComponent as GreyEdge } from '../../../../../assets/icons/graphGreyEdge.svg';
import { ReactComponent as PurpleEdge } from '../../../../../assets/icons/graphPurpluEdge.svg';
import reject_icon from '../../../../../assets/icons/reject_icon.png';
import return_icon from '../../../../../assets/icons/return_icon.png';
import cross_icon from '../../../../../assets/icons/cross_icon.png';
import check_icon from '../../../../../assets/icons/check_icon.png';
import { StatusTag } from 'components';
import styles from './graph.module.scss';

const Graph = () => {
  const apptrackDetails = useSelector(state => state.appTrack.apptrackDetails);
  const businessKey = apptrackDetails?.businessKey;
  const activeTaskName = `task.name.${apptrackDetails?.activeTaskName}`;
  return (
    <div style={{ minHeight: 700, marginBottom: 120 }} className={styles.graphWrapper}>
      <Row gutter={32} className="diagram-container">
        <Col span={24} style={{ paddingBottom: '5.4rem' }}>
          {/* <Divider className="top" /> */}
        </Col>

        <Col span={24} className="main-flow-nodes">
          <div className="point-svg">
            {activeTaskName === 'task.name.submit_application' ? (
              <DarkBluePoint className="point-svg" />
            ) : (
              <BluePoint className="point-svg" />
            )}
            <div className="extra-nodes">
              <div className="extra-dashed-edge"></div>
              <div
                className={
                  // "active-completion-node"
                  activeTaskName === 'task.name.submit_application'
                    ? 'purple-node first'
                    : 'purple-light-node first'
                }
              >
                <span>Σε Επεξεργασία Αίτησης</span>
              </div>
            </div>
          </div>
          {activeTaskName === 'task.name.submit_application' ? (
            <GreyEdge
              className="edge-svg"
              style={{ marginLeft: '-7rem', marginRight: '-8rem' }}
            />
          ) : (
            <BlueEdge
              className="edge-svg"
              style={{ marginLeft: '-7rem', marginRight: '-8rem' }}
            />
          )}
          <div className="point-svg-2">
            <div
              className={
                // "active-completion-node"
                activeTaskName === 'task.name.application_evaluation'
                  ? 'purple-node second'
                  : activeTaskName === 'task.name.application_evaluated' ||
                    activeTaskName === 'task.name.complete'
                  ? 'purple-light-node second'
                  : 'grey-node second'
              }
            >
              <span>Center of Excellence</span>
            </div>
            <div className="extra-nodes-2">
              <div className="extra-dashed-edge-2"></div>
            </div>
            {activeTaskName === 'task.name.application_evaluation' ? (
              <DarkBluePoint className="point-svg" />
            ) : activeTaskName === 'task.name.submit_application' ? (
              <GreyPoint className="point-svg" />
            ) : (
              <BluePoint className="point-svg" />
            )}
          </div>
          {activeTaskName === 'task.name.submit_application' ||
          activeTaskName === 'task.name.application_evaluation' ? (
            <GreyEdge
              className="edge-svg"
              style={{ marginLeft: '-7rem', marginRight: '-7rem' }}
            />
          ) : (
            <BlueEdge
              className="edge-svg"
              style={{ marginLeft: '-7rem', marginRight: '-4rem' }}
            />
          )}
          <div className="point-svg" style={{ marginLeft: '-6rem' }}>
            {activeTaskName === 'task.name.application_evaluated' ? (
              <DarkBluePoint className="point-svg" />
            ) : activeTaskName === 'task.name.complete' ? (
              <BluePoint className="point-svg" />
            ) : (
              <GreyPoint className="point-svg" />
            )}
            <div className="extra-nodes">
              <div className="extra-dashed-edge"></div>
              <div
                className={
                  // "active-completion-node"
                  activeTaskName === 'task.name.application_evaluated'
                    ? 'purple-node third'
                    : activeTaskName === 'task.name.complete'
                    ? 'purple-light-node third'
                    : 'grey-node third'
                }
              >
                <span>Υποβολή Αίτησης</span>
              </div>
            </div>
          </div>
          {activeTaskName === 'task.name.complete' ? (
            <PurpleEdge
              className="edge-svg"
              style={{ marginLeft: '-7rem', marginRight: '-7rem' }}
            />
          ) : (
            <GreyEdge
              className="edge-svg"
              style={{ marginLeft: '-7rem', marginRight: '-7rem' }}
            />
          )}
          <div className="point-svg-2">
            <div
              className={
                // "active-completion-node"
                activeTaskName === 'task.name.complete'
                  ? 'purple-node fourth'
                  : 'grey-node fourth'
              }
            >
              {activeTaskName === 'task.name.complete' ? (
                <a
                  href="https://greece20-loans.gov.gr/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="text-underline">Ολοκλήρωση Αίτησης </span>
                </a>
              ) : (
                <span>Ολοκλήρωση Αίτησης </span>
              )}
            </div>
            <div className="extra-nodes-2">
              <div className="extra-dashed-edge-2"></div>
            </div>
            {activeTaskName === 'task.name.complete' ? (
              <PurplePoint className="point-svg" />
            ) : (
              <GreyPoint className="point-svg" />
            )}
          </div>
        </Col>
      </Row>

      <Row gutter={32}>
        <Col span={24} style={{ height: 56 }}></Col>
      </Row>
    </div>
  );
};

export default Graph;
